import { createContext, useState, useCallback, useEffect } from 'react';
import questionService from '../services/useCases/Question';
import { QuizResponse } from '../services/models';

interface QuizData {
    loading: boolean;
    questions: QuizResponse[];
    currentQuestion: number;
    setCurrentQuestion: React.Dispatch<React.SetStateAction<number>>;
    handleQuestion: (index: number) => void;
    lastQuestion: boolean;
    isSuspect: boolean[];
    isDisabled: boolean[];
};

const QuizContext = createContext<QuizData>({} as QuizData);

export const QuizProvider: React.FC = ({ children }) => {
    const [loading, setLoading] = useState(true);
    const [isDisabled, setIsDisabled] = useState<boolean[]>([]);
    const [isSuspect, setIsSuspect] = useState<boolean[]>([]);
    const [currentQuestion, setCurrentQuestion] = useState(0);
    const [questions, setQuestions] = useState<QuizResponse[]>([]);

    const lastQuestion = currentQuestion === questions.length - 1;

    useEffect(() => {
        async function getQuestion() {
            try {
                const { data } = await questionService.getQuiz();
                const auxIsSuspect: boolean[] = [];
                const auxIsDisabled: boolean[] = [];
                const auxQuestions = data.map((item) => {
                    let auxQuestion = item;
                    auxIsSuspect.push(false);
                    auxIsDisabled.push(true);
                    auxQuestion.answers.map((answer) => {
                        const auxItem = answer;
                        auxItem.answer = false;
                        return auxItem;
                    })
                    return auxQuestion;
                }
                )
                // console.log(auxQuestions);
                setIsDisabled(auxIsDisabled);
                setIsSuspect(auxIsSuspect);
                setQuestions(auxQuestions)
            } catch (error) {
                console.log('error', error)
            } finally {
                setLoading(false)
            }
        }
        getQuestion()
    }, []);

    useEffect(() => {
        const checkDisable = () => {
            let auxQuestion: boolean[] = [...isDisabled];
            const filteredResponse = questions[currentQuestion].answers.some(answer => answer.answer);
            if (filteredResponse) {
                auxQuestion[currentQuestion] = false;
                setIsDisabled(auxQuestion);
            } else {
                auxQuestion[currentQuestion] = true;
                setIsDisabled(auxQuestion);
            };
        }
        if (questions.length !== 0) checkDisable();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentQuestion, questions]);

    const handleQuestion = useCallback((index: number) => {
        const uncheckOthers = (questionIsSuspect: boolean) => {
            if (questionIsSuspect) {
                const filteredResponse = questions[currentQuestion].answers.filter(answer => !answer.isSuspect);
              /* const response = */ filteredResponse.map(answer => {
                    let auxAnswer = answer;
                    auxAnswer.answer = false;
                    return auxAnswer;
                })
                // console.log('Desmarcar Questões não suspeitas: ', response);
            } else {
                const filteredResponse = questions[currentQuestion].answers.filter(answer => answer.isSuspect);
              /* const response = */ filteredResponse.map(answer => {
                    let auxAnswer = answer;
                    auxAnswer.answer = false;
                    return auxAnswer;
                })
                // console.log('Desmarcar Questões suspeitas: ', response);
            }
        };

        const checkIsSuspect = (questionIsChecked: boolean, questionIsSuspect: boolean) => {
            let auxIsSuspect = [...isSuspect];
            if (questionIsChecked && questionIsSuspect) {
                auxIsSuspect[currentQuestion] = true;
                setIsSuspect(auxIsSuspect)
            } else if (questionIsChecked && !questionIsSuspect) {
                auxIsSuspect[currentQuestion] = false;
                setIsSuspect(auxIsSuspect)
            } else {
                const response = questions[currentQuestion].answers.some(answer => answer.answer);
                // console.log('checkIsSuspect: ', response);
                if (response) {
                    auxIsSuspect[currentQuestion] = true;
                    setIsSuspect(auxIsSuspect);
                } else {
                    auxIsSuspect[currentQuestion] = false;
                    setIsSuspect(auxIsSuspect)
                }
            };
        };

        let auxQuestions = [...questions];
        let answer = auxQuestions[currentQuestion].answers[index];
        answer.answer = !answer.answer;
        uncheckOthers(answer.isSuspect);
        checkIsSuspect(answer.answer, answer.isSuspect);
        setQuestions(auxQuestions);
    }, [questions, currentQuestion, isSuspect]);

    return (
        <QuizContext.Provider
            value={{
                questions,
                currentQuestion,
                setCurrentQuestion,
                handleQuestion,
                lastQuestion,
                isSuspect,
                isDisabled,
                loading,
            }}
        >
            {children}
        </QuizContext.Provider>
    );
};

export default QuizContext;